export const extractErrorMessage = (error : any, defaultErrorMessage : string = 'Unkonw error.') : string => {
  if (error instanceof Error) {
    return error.message === '' ? defaultErrorMessage : error.message;
  } if (typeof error === 'string') {
    return error === '' ? defaultErrorMessage : error;
  }
  return defaultErrorMessage;
};
